var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkaleWorkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6982 0L54.6067 25.9084C57.6793 28.981 57.6793 33.9628 54.6066 37.0354L34.2617 57.3803C31.1891 60.453 26.2074 60.453 23.1347 57.3803L2.78983 37.0354C-0.282808 33.9628 -0.282807 28.981 2.78983 25.9084L28.6982 0Z",
    fill: "#30B3D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2858 22.2332L37.5097 26.0093L50.0985 38.5981L53.8746 34.8219L28.6976 60L3.52012 34.8225L28.6976 9.64498L41.2858 22.2332ZM28.6976 60L50.0985 38.5981L28.6972 17.1973L19.8851 26.0094L16.1094 22.2338L3.52012 34.8225L28.6976 60Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkaleWorkIcon);
export default __webpack_public_path__ + "static/media/skaleWorkIcon.70527bbefb64f519678d710c74a6f342.svg";
export { ForwardRef as ReactComponent };